import { useCallback, useEffect } from 'react';
import dashboardSelectors from '../selectors';
import action from '../actions';
import { useAppDispatch } from 'store/hooks';

const useGetSummaryScreens = (isLazy = false) => {
  const dispatch = useAppDispatch();
  const summaryStats = dashboardSelectors.getSummaryStats();

  const mutate = useCallback(() => {
    dispatch(action.getSummaryStats.fetch());
  }, [dispatch]);

  useEffect(() => {
    if (isLazy) return;
    mutate();
  }, []);

  return {
    summaryStats,
    mutate,
  };
};

export default useGetSummaryScreens;
